var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancel-container"},[_c('h1',[_vm._v("Payment Canceled")]),_c('p',[_vm._v("Your payment has been canceled. If this was a mistake, you can try again.")]),_c('router-link',{staticClass:"btn",attrs:{"to":"/"}},[_vm._v("Return to Homepage")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }